export default __webpack_public_path__ + "static/media/RaspberryPi.09961bfd.png";